import AgentSelect from '@src/components/AgentSelect/AgentSelect';
import { contactAssignmentActions } from '@src/reducers/contactAssignment';
import { contactAssignedSelector } from '@src/selectors/contactAssignment';
import { User } from '@src/types';
import {
  ContactAssignmentOptions,
  ContactAssignmentType,
} from '@src/types/contactAssignment';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

type AssignContactToAgentProps = {
  contactId: string;
  readOnly?: boolean;
};

const AssignContactToAgent: React.FC<AssignContactToAgentProps> = ({
  contactId,
  readOnly,
}) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const contactAssignment = useSelector(contactAssignedSelector(contactId));
  const [assignContactToAgent, setAssignContactToAgent] = useState<User>(
    {} as User
  );

  const hasContactAssignment = useMemo(
    () =>
      !!contactAssignment?.id &&
      contactAssignment.type !== ContactAssignmentOptions.UNASIGNED,
    [contactAssignment]
  );

  useEffect(() => {
    if (contactAssignment?.type === ContactAssignmentOptions.AGENT)
      setAssignContactToAgent({
        id: contactAssignment.id,
        fullName: contactAssignment.description,
      } as User);
  }, [contactAssignment]);

  const handleContactAssignmentToAgent = (agent: User) => {
    if (agent?.id && agent?.id !== contactAssignment?.id) {
      setAssignContactToAgent(agent);
      dispatch(
        contactAssignmentActions.assignContact({
          contactId,
          assignedTo: {
            id: agent.id,
            description: agent.fullName,
            type: ContactAssignmentOptions.AGENT as ContactAssignmentType,
          },
          replace: hasContactAssignment,
        })
      );
    }
  };

  return (
    <>
      {/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore */}
      <AgentSelect
        disabled={readOnly}
        size="small"
        withStatus={false}
        placeholder={formatMessage({ id: 'AgentSelect.Placeholder' })}
        value={assignContactToAgent as User}
        onChange={(_, agent) => handleContactAssignmentToAgent(agent as User)}
      />
    </>
  );
};

export default AssignContactToAgent;
